import React from "react";
import { Box, Typography, List, ListItem, Divider } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";

const RecentActivities = () => {
  const activities = [
    { date: "Today", description: "Lorem ipsum dolor sit amet consectetur" },
    { date: "17 May", description: "Debitis nesciunt voluptatem dicta reprehenderit" },
    { date: "13 May", description: "Accusamus voluptatem voluptas." },
    { date: "05 April", description: "At vero eos et accusamus et iusto odio dignissi" },
    { date: "26 Mar", description: 'Responded to need "Volunteer Activities"' },
  ];

  return (
    <Box
      sx={{
        Width: 200,
        margin: "0 auto",
        padding: 0.60,
        backgroundColor: "white",
        borderRadius: 2,
        boxShadow: 2,
      }}
    >
      <Typography
        variant="h6"
        fontWeight="bold"
        gutterBottom
        sx={{ textAlign: "left", marginBottom: 2 }}
      >
        Recent activities
      </Typography>
      <List disablePadding>
        {activities.map((activity, index) => (
          <React.Fragment key={index}>
            <ListItem
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "8px 0",
              }}
            >
              
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: index === 0 ? "bold" : "normal",
                    minWidth: "80px",
                    textAlign: "left",
                    color: index === 0 ? "primary.main" : "text.secondary",
                  }}
                >
                  {activity.date}
                </Typography>
                    <ArrowForward
                sx={{
                  color: "success.main",
                  fontSize: 20,
                }}
              />
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "normal",
                    color: "text.primary",
                    flex: 1,
                  }}
                >
                  {activity.description}
                </Typography>
              </Box>
         
            </ListItem>
            {index !== activities.length - 1 && (
              <Divider sx={{ borderColor: "grey.300" }} />
            )}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default RecentActivities;